<template>
  <router-view v-slot="{ Component }">
    <keep-alive>
      <component :key='route.path.split("/").slice(0, 3).join("/")' class='view' :is="Component" />
    </keep-alive>
  </router-view>
</template>

<script setup>
  import { useRoute } from 'vue-router';
  const emit = defineEmits(['transitionStarted', 'transitionEnded'])
  const route = useRoute()
</script>
